import Entity from '../entity'

export default class AgreementMeasure extends Entity<number>{
    agreement_id: number;
    description: string;
}


